
// ECTS injected JS: normalize whatsapp and set href
document.addEventListener('DOMContentLoaded', function(){
  var wa = document.getElementById('ects-whatsapp');
  if(!wa) return;
  // Attempt to read phone from theme settings (Shopify will render settings into templates if used)
  var raw = "{{ settings.whatsapp_number | escape }}";
  var msg = "{{ settings.whatsapp_message | escape }}";
  function normalize(n){
    if(!n) return '';
    var digits = n.replace(/[^0-9]/g,'');
    if(digits.length==0) return '';
    if(digits.length==10) digits = '20'+digits;
    return digits;
  }
  var num = normalize(raw);
  if(num){
    var encoded = encodeURIComponent(msg || '');
    wa.href = 'https://wa.me/' + num + (encoded? '?text='+encoded : '');
  } else {
    // fallback: try shop.phone rendered in a data attribute
    var fallback = document.querySelector('meta[name="shop-phone"]');
    if(fallback){
      var ph = fallback.getAttribute('content') || '';
      var n2 = normalize(ph);
      if(n2){ wa.href = 'https://wa.me/' + n2; return; }
    }
    wa.style.display = 'none';
  }
});
